import { render } from "./HistorialView.vue?vue&type=template&id=1ef51cd4"
import script from "./HistorialView.vue?vue&type=script&lang=js"
export * from "./HistorialView.vue?vue&type=script&lang=js"

import "./HistorialView.vue?vue&type=style&index=0&id=1ef51cd4&lang=css"

import exportComponent from "D:\\laragon\\www\\balkum-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__